//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uParse from '@/components/gaoyia-parse/parse.vue'
import moment from 'dayjs'
export default {
	data() {
		return {
			//swiper轮播图
			indicatorDots: false, //是否显示面板指示点
			circular: true, //是否采用衔接滑动
			autoplay: true, //是否自动切换
			interval: 3000, //自动切换时间间隔
			duration: 500, //滑动动画时长
			imgList: [], //轮播图数组
			id: '',
			detail: {},
		}
	},
	components: {
		uParse
	},
	onLoad(event) {
		this.id = event.id
		this.queryData()
	},
	methods: {
		changeImg() {},
		jump() {
			uni.navigateTo({
				url: '/pages/common/images?image=' + this.imgList
			})
		},
		showPosition() {
			if (this.detail.latitude && this.detail.longitude) {











				wx.openLocation({
					latitude: parseFloat(this.detail.latitude), // 纬度，浮点数，范围为90 ~ -90
					longitude: parseFloat(this.detail.longitude), // 经度，浮点数，范围为180 ~ -180。
					name: this.detail.place, // 位置名
					address: this.detail.place, // 地址详情说明
					scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
					infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
				})

			}
		},
		queryData() {
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/activity/queryById',
				data: {
					id: this.id
				}
			}).then(res => {
				res.data.startTime = moment(res.data.startTime).format(
					'YYYY-MM-DD'
				)
				res.data.endTime = moment(res.data.endTime).format('YYYY-MM-DD')
				this.detail = res.data
				this.imgList = res.data.photoImages ?
					res.data.photoImages.split(',') :
					''
			})
		}
	}
}
